module.exports = __webpack_public_path__ + "static/media/hotjar-03.858a1a66.svg";